import { render, staticRenderFns } from "./RDataBrandCard.vue?vue&type=template&id=47e9b11a&scoped=true&"
import script from "./RDataBrandCard.vue?vue&type=script&lang=js&"
export * from "./RDataBrandCard.vue?vue&type=script&lang=js&"
import style0 from "./RDataBrandCard.vue?vue&type=style&index=0&id=47e9b11a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e9b11a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
